module.exports = __webpack_public_path__ + "img/buildings.971934cf.svg";